"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountDown = exports.defaultCountDownText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var hooks_1 = require("../../../../hooks");
var material_1 = require("@mui/material");
exports.defaultCountDownText = {
    wait: 'Your estimated wait is',
    seconds: 'seconds...',
    down: 'Currently, app is down. Please try again later.',
};
var CountDown = function (_a) {
    var seconds = _a.seconds, _b = _a.retriesLeft, retriesLeft = _b === void 0 ? 0 : _b, _c = _a.text, text = _c === void 0 ? exports.defaultCountDownText : _c;
    var theme = (0, hooks_1.useGracefulTheme)();
    var _d = (0, react_1.useState)(seconds), timeLeft = _d[0], setTimeLeft = _d[1];
    (0, react_1.useEffect)(function () {
        if (!retriesLeft)
            return;
        setTimeLeft(seconds);
    }, [retriesLeft]);
    (0, react_1.useEffect)(function () {
        if (!timeLeft) {
            return;
        }
        var intervalId = setInterval(function () {
            setTimeLeft(timeLeft - 1);
        }, 1000);
        return function () { return clearInterval(intervalId); };
    }, [timeLeft]);
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { children: timeLeft ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({}, {
                    fontSize: 16,
                    fontWeight: '400',
                }, { children: text.wait })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({}, {
                    fontSize: 24,
                    fontWeight: '800',
                    textAlign: 'center',
                    sx: { color: theme.primary },
                }, { children: "".concat(timeLeft, " ").concat(text.seconds) }))] })) : ((0, jsx_runtime_1.jsx)(material_1.Typography, __assign({}, {
            fontSize: 16,
            fontWeight: '400',
            sx: { color: theme.secondary },
        }, { children: text.down }))) }));
};
exports.CountDown = CountDown;
